/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
import _ from 'underscore';

import { makeHttpRequest } from './actions';

export const ActionSet = {
  REQUEST: 'REQUEST',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export function makeAsyncActionSet(actionName) {
  return _.mapObject(ActionSet, each => `${actionName}_${each}`);
}

export const LOGIN = makeAsyncActionSet('LOGIN');
export function login(email, password, keepLoggedIn) {
  return makeHttpRequest(
    LOGIN,
    '/api/users/login/',
    'POST',
    { email, password, keep_logged_in: keepLoggedIn },
  );
}

export const LOGOUT = makeAsyncActionSet('LOGOUT');
export function logout() {
  return makeHttpRequest(
    LOGOUT,
    '/api/users/logout/',
    'POST',
  );
}

export const UPLOAD_FILE = makeAsyncActionSet('UPLOAD_FILE');
export function uploadFile(file, form, field) {
  return makeHttpRequest(
    UPLOAD_FILE,
    '/api/files/',
    'POST',
    { file },
    { form, field },
  );
}

export const GET_USER_INFO = makeAsyncActionSet('GET_USER_INFO');
export function getUserInfo() {
  return makeHttpRequest(
    GET_USER_INFO,
    '/api/users/me/',
    'GET',
    null,
    { dontTimeout: true },
  );
}

export const UPDATE_USER_INFO = makeAsyncActionSet('UPDATE_USER_INFO');
export function updateUserInfo(data) {
  return makeHttpRequest(
    UPDATE_USER_INFO,
    '/api/users/me/',
    'PATCH',
    data,
  );
}

export const UPDATE_USER_PASSWORD = makeAsyncActionSet('UPDATE_USER_PASSWORD');
export function updateUserPassword(data) {
  return makeHttpRequest(
    UPDATE_USER_PASSWORD,
    '/api/users/password/change/',
    'POST',
    data,
  );
}

export const REDEEM_INVITE = makeAsyncActionSet('REDEEM_INVITE');
export function redeemInvite(inviteId, data) {
  return makeHttpRequest(
    REDEEM_INVITE,
    `/api/invites/${inviteId}/redeem/`,
    'POST',
    data,
  );
}

export const SEND_RECOVERY_LINK = makeAsyncActionSet('SEND_RECOVERY_LINK');
export function sendRecoveryLink(email) {
  return makeHttpRequest(
    SEND_RECOVERY_LINK,
    '/api/users/password/reset/',
    'POST',
    { email },
  );
}

export const RESET_PASSWORD = makeAsyncActionSet('RESET_PASSWORD');
export function resetPassword(uid, token, password) {
  return makeHttpRequest(
    RESET_PASSWORD,
    `/api/users/password/reset/${uid}/${token}/`,
    'POST',
    { new_password1: password, new_password2: password },
  );
}

export const GET_REPORTS_INFO = makeAsyncActionSet('GET_REPORTS_INFO');
export function getReportsInfo() {
  return makeHttpRequest(
    GET_REPORTS_INFO,
    '/api/reports/',
    'GET',
  );
}

export const LOCK_ITEM = makeAsyncActionSet('LOCK_ITEM');
export function lockItem(type, id, source = type) {
  return makeHttpRequest(
    LOCK_ITEM,
    `/${type}/${id}/lock/`,
    'PATCH',
    null,
    { collectionName: source },
    source,
  );
}

export const UNLOCK_ITEM = makeAsyncActionSet('UNLOCK_ITEM');
export function unlockItem(type, id, source = type) {
  return makeHttpRequest(
    UNLOCK_ITEM,
    `/${type}/${id}/unlock/`,
    'PATCH',
    null,
    { collectionName: source },
    source,
  );
}

export const HIDE_TENANT_USER = makeAsyncActionSet('HIDE_TENANT_USER');
export function hideTenantUser(tenantId, userId) {
  return makeHttpRequest(
    HIDE_TENANT_USER,
    `/api/tenants/${tenantId}/users/${userId}/remove/`,
    'PATCH',
    null,
  );
}

export const SEARCH_USERS = makeAsyncActionSet('SEARCH_USERS');
export function searchUsers(firstName, lastName, email) {
  const data = {
    first_name: firstName.length === 0 ? null : firstName,
    last_name: lastName.length === 0 ? null : lastName,
    email: email.length === 0 ? null : email,
  };

  return makeHttpRequest(
    SEARCH_USERS,
    '/api/tenantusers/search/',
    'POST',
    data,
  );
}
